"use strict";
/**
 *  Code reference taken from src/families/ethereum/postSyncPatch.ts
 */
exports.__esModule = true;
// we need to preserve ADA pendingOperations because there is no mempool to do this
// we assume we need to preserve until:
// - that txid appears in operations
var postSyncPatchGen = function (initial, synced, parentPendingOperation) {
    var pendingOperations = initial.pendingOperations || [];
    if (pendingOperations.length === 0)
        return synced;
    var operations = synced.operations;
    synced.pendingOperations = pendingOperations.filter(function (op) {
        return (!parentPendingOperation || // a child pending parent need to disappear if parent ada op disappear
            parentPendingOperation.some(function (o) { return o.hash === op.hash; })) &&
            !operations.some(function (o) { return o.hash === op.hash; });
    } // after retain logic, we need operation to appear
    );
    return synced;
};
var postSyncPatch = function (initial, synced) {
    var acc = postSyncPatchGen(initial, synced);
    var subAccounts = acc.subAccounts, pendingOperations = acc.pendingOperations;
    var initialSubAccounts = initial.subAccounts;
    if (subAccounts && initialSubAccounts) {
        acc.subAccounts = subAccounts.map(function (subAccount) {
            var initialSubAccount = initialSubAccounts.find(function (a) { return a.id === subAccount.id; });
            if (!initialSubAccount)
                return subAccount;
            return postSyncPatchGen(initialSubAccount, subAccount, pendingOperations);
        });
    }
    return acc;
};
exports["default"] = postSyncPatch;
//# sourceMappingURL=postSyncPatch.js.map